export default "__VITE_ASSET__28dH52uE__"